<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <app-carousel [images]="[image]" [showGradient]="true">
    </app-carousel>
    <ng-template [ngTemplateOutlet]="results"></ng-template>
    <app-footer/>
  </app-page-template>

  <ng-template #results>
    <section class="upper-section-background">
      <div class="container padding-bottom-92 pt-62-32 pb-300-228">
        <div class="row row-cols-1">
          @if (liveEvents.length > 0) {
            <div>
              @for (liveEvent of liveEvents;track liveEvent) {
                <div>
                  <app-live-event [liveEvent]="liveEvent"
                                  [languages]="languages" [countries]="countries"/>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </section>
  </ng-template>
</ng-container>
